module.exports = __webpack_public_path__ + "static/media/help6.51fef15d.png";